import styles from "./LoadingPage.module.css";
import {Button, Divider, Form, Image, Input, Select, Spin} from "antd";
import logoBlue from "../../../../img/tillit_logo_blue.svg";
import React from "react";

const LoadingPage = () => {
    return (
        <div className='loading-page' style={{backgroundColor: `var(--background)`, height: "100vh"}}>
            <div className={styles.loading_wrap}>
                <Image
                    style={{width: "100px"}}
                    className={styles.login_logo}
                    preview={false}
                    src={logoBlue}
                />
                <div className={styles.loading_title}>
                    <span>Loading...</span>
                </div>
                <div className={styles.login_form}>
                    <p className='loading-msg'>
                        Datashaper is loading up its required API services for flawless operation. Thank you for your patience.{' '}
                    </p>
                    <p className='loading-msg'>
                        If Datashaper is not loaded shortly, please contact administrator to check for potential issues.
                    </p>
                </div>
            </div>
        </div>
)
    ;
};

export default LoadingPage;